// assets
import { IconCalendarEvent, IconBrandGoogleAnalytics } from '@tabler/icons';

// constant
const icons = { IconCalendarEvent, IconBrandGoogleAnalytics };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const consultorio = {
    id: 'consultorio',
    title: 'Consultorio',
    caption: 'Administración del Consultorio',
    type: 'group',
    children: [
        {
            id: 'calendario-page',
            title: 'Calendario',
            type: 'item',
            url: '/agenda',
            icon: icons.IconCalendarEvent,
            breadcrumbs: false
        },
        {
            id: 'analytics-page',
            title: 'Métricas',
            type: 'item',
            icon: icons.IconBrandGoogleAnalytics,
            url: '/analytics'
        }
    ]
};

export default consultorio;
